import React, { useState } from "react";
import {
    Layout,
    Typography,
    Breadcrumb,
    Select,
    Button,
    Table,
    Row,
    Col,
    Space,
    Spin,
    Form,
    Card,
    Input
} from "antd";
import { ClearOutlined, FileExcelOutlined, SearchOutlined } from "@ant-design/icons";
import axios from "axios";
import { Link } from "react-router-dom";
import { APPBACKGROUND_COLOR, MAINAPIURL } from "../../appsettings.js";
import { AlertError } from "../../usableclasses.js";
import Headerdiv from "../../layout/header.js";
import Footerdiv from "../../layout/footer.js";
import { exportMLMUserMonthlyPerformanceByConsultantExcel } from "./mlm-user-monthly-performance-by-consultant-excel .js";

const { Title } = Typography;
const { Content } = Layout;

const columns = [
    { title: "Year", dataIndex: "sysyear", key: "sysyear" },
    { title: "Month", dataIndex: "sysmonth", key: "sysmonth" },
    { title: "Consulton ID", dataIndex: "mlmuserid", key: "mlmuserid" },
    { title: "First Name", dataIndex: "mlmfirstname", key: "mlmfirstname" },
    { title: "Second Name", dataIndex: "mlmsecondname", key: "mlmsecondname" },
    { title: "Sponsor ID", dataIndex: "sponsorid", key: "sponsorid" },
    { title: "Self Point", dataIndex: "mlmselfponit", key: "mlmselfponit" },
    { title: "Group Point", dataIndex: "mlmgroupponit", key: "mlmgroupponit" },
    { title: "Self BV", dataIndex: "mlmselfbv", key: "mlmselfbv" },
    { title: "Group BV", dataIndex: "mlmgroupbv", key: "mlmgroupbv" },
    { title: "Self Per Discount", dataIndex: "mlmselfperdiscount", key: "mlmselfperdiscount" },
    { title: "Group Earn", dataIndex: "mlmgroupperamount", key: "mlmgroupperamount" },
    { title: "Self Earn", dataIndex: "mlmselfperamount", key: "mlmselfperamount" },
    { title: "Month Total Earn", dataIndex: "mlmmonthtotalearn", key: "mlmmonthtotalearn" },
];


const getYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 6 }, (_, i) => currentYear - i);
};

const months = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
];

const MLMUserMonthlyReportByConsultant = () => {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const [isLoading, setIsLoading] = useState(false);
    const [userList, setUserList] = useState([]);
    const [status, setStatus] = useState("ALL");
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [consultantId, setConsultantId] = useState("");


    const fetchUserPerfomance = async (statusValue = status, yearValue = year, monthValue = month) => {
        try {
            setIsLoading(true);
            const headers = { SystemAccessToken: TOKEN };
            const formattedMonth = monthValue.toString().padStart(2, '0');
            const res = await axios.get(
                `${ApiURL}/reports/mlm/userlisthistorysummarybyconsultant/${yearValue}/${formattedMonth}/${consultantId}`,
                { headers }
            );
            setUserList(res.data);
        } catch (error) {
            AlertError("Failed to Load MLM User List");
        } finally {
            setIsLoading(false);
        }
    };

    const handleMLMUserMonthlyPerformanceReportExportToExcel = () => {
        exportMLMUserMonthlyPerformanceByConsultantExcel(userList);
    }

    return (
        <Spin spinning={isLoading} tip="Processing...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
                <Headerdiv />
                <Content style={{ padding: "10px" }}>
                    <Breadcrumb style={{ margin: "16px 0" }}>
                        <Breadcrumb.Item><Link to={"/reports"}>Reports</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>MLM User Performance Report By Consultant</Breadcrumb.Item>
                    </Breadcrumb>
                    <Card style={{ marginBottom: 20 }} title={
                        <Row align="middle" justify="space-between">
                            <Col span={12}>
                                <Title level={4} style={{ textAlign: 'left', margin: 0 }}>MLM User Performance Report By Consultant</Title>
                            </Col>
                            <Col span={12} style={{ textAlign: 'right' }}>
                                <Space>
                                    <Button
                                        disabled={userList.length === 0}
                                        type="primary"
                                        icon={<FileExcelOutlined />}
                                        style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                                        onClick={handleMLMUserMonthlyPerformanceReportExportToExcel}
                                    >
                                        Export to Excel
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    }>
                        <Form layout="inline" style={{ width: '100%' }} onFinish={() => fetchUserPerfomance(status, year, month)}>
                            <Row align="middle" gutter={[16, 16]} style={{ width: '100%' }}>
                                <Col xs={24} sm={12} md={5}>
                                    <Form.Item label="Year" style={{ marginBottom: 0 }}>
                                        <Select
                                            style={{ width: '100%' }}
                                            value={year}
                                            onChange={value => setYear(value)}
                                            options={getYears().map(y => ({ value: y, label: y }))}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={5}>
                                    <Form.Item label="Month" style={{ marginBottom: 0 }}>
                                        <Select
                                            style={{ width: '100%' }}
                                            value={month}
                                            onChange={value => setMonth(value)}
                                            options={months}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col>
                                    <Form.Item label="Consultan ID" style={{ marginBottom: 0 }}>
                                        <Input
                                            required
                                            style={{ width: '100%' }}
                                            value={consultantId}
                                            onChange={e => setConsultantId(e.target.value)}
                                            placeholder="Enter Consultant ID"
                                            type="number"
                                            min={0}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={3} style={{ display: 'flex', alignItems: 'end' }}>
                                    <Button
                                     htmlType="submit"
                                      type="primary"
                                      icon={<SearchOutlined/>}
                                     style={{ width: '100%' }}>Get Data</Button>
                                </Col>
                                <Col xs={24} sm={12} md={3} style={{ display: 'flex', alignItems: 'end' }}>
                                    <Button
                                        style={{ width: '100%' }}
                                        icon={<ClearOutlined />}
                                        onClick={() => {
                                            setStatus("ALL");
                                            setUserList([]);
                                            setConsultantId("")
                                            setYear(new Date().getFullYear());
                                            setMonth(new Date().getMonth() + 1);
                                        }}
                                    >
                                        Clear
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                    <Card title="MLM Users" style={{ marginBottom: 20 }}>
                        <Table
                            style={{ marginTop: 20 }}
                            columns={columns}
                            dataSource={userList}
                            pagination={false}
                            bordered
                            scroll={{ x: "max-content" }}
                            rowKey={record => record.consultid}
                        />
                    </Card>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
};

export default MLMUserMonthlyReportByConsultant;
